export const SITE_UNAVAILABLE_POPUP_FLAG = 'siteUnavailablePopupConfirmed';

export const SITE_UNAVAILABLE_POPUP_MESSAGE =
  'Due to necessary maintenance work, the website will be temporarily unavailable on Thursday, January 23rd from 7:30 to 13:30 UTC. We apologize for the inconvenience.';

export const SITE_UNAVAILABLE_POPUP_TITLE = 'Important Announcement';
export const SITE_UNAVAILABLE_POPUP_CLOSE = 'Close';

export const SITE_UNAVAILABLE_POPUP_EXPIRATION = Date.UTC(2025, 0, 23, 7, 30);
